module.exports = __webpack_public_path__ + "img/prize-02.c3e0c7ae.png";